class BannerGridVideo {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.triggers = document.querySelectorAll(`#BannerGrid-${sectionId} .banner-grid-section__item.has-video`);
    this.modal = document.getElementById(`VideoModal-${sectionId}`);
    this.video = this.modal.querySelector('video');
    this.closeBtn = this.modal.querySelector('.video-modal__close');
    this.overlay = this.modal.querySelector('.video-modal__overlay');

    // Move modal to end of body for true fullscreen overlay
    if (this.modal && this.modal.parentNode !== document.body) {
      document.body.appendChild(this.modal);
    }

    this.init();
  }

  open(videoUrl) {
    this.video.querySelector('source').src = videoUrl;
    this.video.load();
    this.modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.setAttribute('hidden', '');
    this.video.pause();
    this.video.currentTime = 0;
    document.body.style.overflow = '';
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const videoUrl = trigger.dataset.videoUrl;
        if (videoUrl) {
          this.open(videoUrl);
        }
      });
    });

    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => {
      if (!this.modal.hasAttribute('hidden') && e.key === 'Escape') {
        this.close();
      }
    });
  }
}

window.BannerGridVideo = BannerGridVideo; 